<template>

    <modal-container>

        <!-- Top navbar -->
        <modal-header
            :title="'Benefits of Marketplace'"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <!-- Prompt content -->
        <prompt-div class="text-dark">

            <!-- Layout body -->
            <template v-slot:body>
                <lottie class="h-80" :options="{animationData: animationData}"/>
                <div class="pt-6">
                    <h3 class="font-lg font-weight-bolder mx-4">With Marketplace you have a mall in your pocket</h3>
                    <div class="d-flex justify-content-center mt-4">
                        <div class="text-left mt-4">
                            <list-icon v-for="(text, key) in bulletPoints" :key="key">
                                <template v-slot:icon>
                                    <img src="images/content-tag-heart.svg">
                                </template>
                                <template v-slot:description>{{ text }}</template>
                            </list-icon>
                        </div>
                    </div>
                </div>

            </template>

            <!-- Bottom button -->
            <template v-slot:bottom-button>
                <button class="btn btn-lg btn-inverted btn-block text-primary" @click="$root.closeModal()">
                    Got it!
                </button>
            </template>
        </prompt-div>
    </modal-container>

</template>

<script>
    export default {
        data: function() {
            return {
                animationData: require('../../assets/mpl-guide-pickup.json'),
                bulletPoints: [
                    'Choose from hundreds of products',
                    'Apply for 0% installment product loan',
                    'Visit partner store to pick up your item',
                ]
            }
        },
    }
</script>

<style scoped>
.prompt-container {
    margin: 0 2.8rem 1rem 2.8rem; /** override for text wrap **/
}
</style>
